@use '~/theme/theme' as *;
@use '~/theme/typography';

@keyframes fadein {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fadeout {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.popover {
  background: white;
  outline: none;

  @include shadow(md);
  @include border-radius(sm);

  overflow: hidden;
  min-width: var(--trigger-width);
  max-width: var(--trigger-max-width, 400px);
  display: flex;
  flex-direction: column;

  &[data-entering] {
    opacity: 0;
    animation: fadein 100ms linear;
  }

  &[data-exiting] {
    opacity: 1;
    animation: fadeout 100ms linear;
  }
}

.listBox {
  overflow: auto;
  flex: 1 1 auto;
  min-height: 0;

  .header {
    padding: spacing(1.5);
    padding-bottom: spacing(0.5);

    @include typography.caption;
    @include typography.semibold;
  }
}

.listBox:focus-visible {
  outline: 0;
}

.item {
  .media {
    max-width: 32px;
    max-height: 32px;
    overflow: hidden;
    flex-shrink: 0;
    line-height: 0;
  }

  .label {
    @include typography.ellipsis;

    flex-grow: 1;
    cursor: pointer;
  }

  .wrapLabel {
    overflow: visible;
    white-space: normal;
    text-overflow: initial;
    overflow-wrap: break-word;
  }

  padding: spacing(1.5);

  @include typography.body2;
  @include typography.regular;

  cursor: pointer;
  outline: 0;
  display: flex;
  align-items: center;
  gap: 12px;

  [slot='label'] {
    flex-grow: 1;

    @include typography.body2;
    @include typography.regular;
  }

  [slot='description'] {
    @include typography.caption;
    @include typography.medium;

    overflow-wrap: break-word;
    color: color(grey-600);
  }

  .icon {
    @include icon-size(sm);
  }

  .check {
    display: none;
    margin-left: spacing(2);
    flex-shrink: 0;

    @include icon-size(sm);
  }

  .actionWithCheck {
    display: flex;
    align-items: center;
    flex-shrink: 0;

    .check {
      display: unset;
      visibility: hidden;
    }
  }

  .endIcon {
    margin-left: spacing(2);
    flex-shrink: 0;

    @include icon-size(sm);
  }

  &[data-disabled] {
    cursor: not-allowed;
    pointer-events: none;
    background: color(grey-100);

    &:hover {
      background: color(grey-100);
    }

    .icon,
    .check {
      color: color(grey-500);
    }

    [slot='label'] {
      color: color(grey-500);
    }

    [slot='description'] {
      color: color(grey-500);
    }

    .media {
      filter: grayscale(100%);
    }
  }

  .itemText {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex-grow: 1;
    min-width: 0;
  }

  .labelContainer {
    display: flex;
    align-items: center;

    > span {
      min-width: 0;
    }
  }

  &[data-focused] {
    background: color(violet-100);
  }

  &[data-selected] {
    [slot='label'] {
      @include typography.semibold;
    }

    .check {
      display: unset;
    }

    .actionWithCheck .check {
      visibility: visible;
    }
  }

  &[data-focus-visible] {
    background: color(violet-100);
  }

  &:hover:not(:has(button:hover)) {
    background-color: color(violet-100);
  }
}

.stickyFooter {
  flex: 0 0 auto;
  position: sticky;
  bottom: 0;
  background-color: white;
}

.stickyHeader {
  flex: 0 0 auto;
  padding: spacing(1.5);
  background-color: white;
  color: color(grey-600);

  @include typography.caption;
  @include typography.regular;
}

.loadMoreItem {
  display: flex;
  justify-content: center;
  padding: spacing(1.5);
  color: color(violet-600);
}

.leadingIcon {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
